export const FEEDBACK_SELF_RELEASE_REFRESH_GUARD_MS = 10_000;

const equalIgnoringEdgeWhitespace = (a: string, b: string): boolean =>
  a === b || a.trim() === b.trim();

export type FeedbackRefreshResolution = {
  currentText: string;
  originalText: string;
  preservedLocalEdit: boolean;
};

/**
 * サーバー再取得中にローカルの未保存入力を巻き戻さないための解決規則。
 * originalText は比較基準として最新サーバー値へ進めつつ、編集中の値だけを保持する。
 */
export const resolveFeedbackAfterServerRefresh = ({
  currentText,
  originalText,
  serverText,
}: {
  currentText: string;
  originalText: string;
  serverText: string;
}): FeedbackRefreshResolution => {
  const preservedLocalEdit = !equalIgnoringEdgeWhitespace(currentText, originalText);
  return {
    currentText: preservedLocalEdit ? currentText : serverText,
    originalText: serverText,
    preservedLocalEdit,
  };
};

/** 古い保存処理の完了通知で、新しい編集セッションを idle に戻さない。 */
export const canCompleteFeedbackSave = (
  currentInteractionRevision: number,
  saveInteractionRevision: number
): boolean => currentInteractionRevision === saveInteractionRevision;

/** 自分の編集終了通知による直後の再取得は、結果整合の遅延で旧値を返し得るため抑止する。 */
export const isRecentSelfRelease = (
  releasedAt: number | undefined,
  now: number,
  guardMs = FEEDBACK_SELF_RELEASE_REFRESH_GUARD_MS
): boolean =>
  typeof releasedAt === 'number' &&
  Number.isFinite(releasedAt) &&
  now >= releasedAt &&
  now - releasedAt <= guardMs;
